import { animate, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material';
import { I18N } from 'ess-plugin-base';
import { DataItem } from '../model/data.item';
import { interval, timer } from 'rxjs';


/**
 * Animated tree view with search box on top to filter and highlight items.
 */
@Component({
    selector: 'ess-search-tree',
    templateUrl: './search.tree.html',
    styleUrls: ['./search.tree.scss'],
    animations: [

        trigger('expandTree', [
          transition('true=>false', [
            style({ opacity:0 }),
            animate(600)
          ]),
          transition('false=>true', [
            style({ opacity:1 }),
            animate(600)
          ])
    
        ])
      ]
    
})
export class SearchableTree implements OnInit, OnChanges {

    /**
     * The tree nodes to display.
     */
    @Input('data')
    data: DataItem[];

    selected: DataItem = null;

    /**
     * Event fired when an item is selected.
     */
    @Output('select')
    onSelect: EventEmitter<DataItem> = new EventEmitter<DataItem>();

    treeControl = new NestedTreeControl<DataItem>(node => node.children);
    dataSource = new MatTreeNestedDataSource<DataItem>();

    phrase: string;

    // @Input('search-function')
    // search_function: (string: string, array: DataItem[]) => DataItem[];

    /**
     * Name of a function to call when search is performed.
     * <br>
     * Useful to override default searching and fetch items from  a web service for example.
     */
    @Input('search-matcher')
    search_matcher: (string: string, item: DataItem) => boolean;

    constructor(public i18n: I18N) { }

    ngOnInit() {
        if (this.data) {
            this.dataSource = new MatTreeNestedDataSource<DataItem>();
            this.dataSource.data = this.data;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.dataSource = null;
            timer(300).toPromise().then(() => {
                if (this.data) {
                    this.dataSource = new MatTreeNestedDataSource<DataItem>();
                    this.dataSource.data = this.data;
                }
                else {
                    this.dataSource = new MatTreeNestedDataSource<DataItem>();
                    // this.dataSource.data = null;
                }
            })        
        }
    }

    ngOnDestroy() {
    }

    hasChild = (_: number, node: any) => !!node && !!node.children && node.children.length > 0;

    openMenuItem(node: DataItem) {
        if (node) {
            this.selected = node;
            this.onSelect.emit(node);
        }
    }

    doSearch() {
        // if (this.search_function) {
        //     let open = this.search_function(this.phrase, this.data);
        //     for(let one of open || []) {
        //         this.doExpand(one)
        //     }
        // }
        // else 
        if (this.search_matcher) {
            this.matchNodes(this.phrase, this.data);
            // let matches = this.data.filter(item => this.search_matcher(this.phrase, item));
            // if (matches) {
            //     matches.map(item => this.doExpand(item))
            // }
        }
    }

    private matchNodes(phrase: string, array: DataItem[]): boolean {
        let expand_this = false;

        for (let item of array) {
            this.treeControl.collapse(item);

            item['__matched'] = phrase && phrase.length && this.search_matcher(phrase, item);
            if (item['__matched']) {
                // this.treeControl.expand(item);
                expand_this = true;
            }

            if (this.matchNodes(phrase, item.children)) {
                this.treeControl.expand(item);
                expand_this = true;
            } else {
                this.treeControl.collapse(item);
            }
        }
        return expand_this;
    }

    /*doExpand(item: DataItem) {
        if (!this.dataSource || !this.dataSource.data) return;

        for(let node of this.dataSource.data) {
            node['__matched'] = (node == item);
            if (node == item) {
                this.treeControl.expand(node)
            } else {
                if (this.expandParent(item, node)) {
                    this.treeControl.expand(node)
                }
            }
        }
    }

    private expandParent(item: DataItem, parent: DataItem): boolean {
        let expand_this = false;

        if (item && parent.children && parent.children.length) {
            for(let child of parent.children) {
                child['__matched'] = (child == item);
                if (child == item) {
                    this.treeControl.expand(child)
                    expand_this = true;

                } else {
                    if (this.expandParent(item, child)) {
                        this.treeControl.expand(child);
                        expand_this = true;
                    }
                }
            }
        }
        return expand_this;
    }*/
    
}